import { useMemo } from "react";
import { ExchangeStatusWrapper } from "ui";
import { useHashConnect, useExchangeRate, useAccount, useAPY } from "hooks";

// const
import {
  NATIVE_TOKEN_MULTIPLIER,
  precision,
  tvlPrecision,
} from "constants/constants";

// components
import { WalletStatus } from "components/ConnectWalletDropdown/ConnectWalletDropdown";

// config
import { config } from "config/config";

const ExchangeInfo = () => {
  const { apy } = useAPY();
  const { exchangeRate } = useExchangeRate();
  const { tvl, status } = useHashConnect();
  const { hbarX } = useAccount();
  const { coinName, coinNameX } = config;

  const tvlFloor = useMemo(() => {
    if (!tvl) return "-";
    return parseFloat(tvl.toFixed(tvlPrecision)).toLocaleString(undefined, {
      maximumFractionDigits: tvlPrecision,
    });
  }, [tvl]);

  const apyValue = useMemo(() => {
    if (!apy) return "-";
    return apy.toFixed(precision) + "%";
  }, [apy]);

  const rate = useMemo(() => {
    if (!exchangeRate) return "-";
    return `${((1 / exchangeRate) * NATIVE_TOKEN_MULTIPLIER).toFixed(
      precision
    )}`;
  }, [exchangeRate]);

  const exchangeStatusData = [
    {
      title: "TVL",
      value: tvlFloor,
      option: coinName,
      tooltip: "Total HBAR in stake pool",
    },
    {
      title: "APY",
      value: apyValue,
      option: "",
      tooltip: "Estimated annualized return",
    },
    {
      title: `${coinName}/${coinNameX} exchange rate`,
      value: rate,
      option: "",
      tooltip: "Actual exchange rate may vary from displayed value",
    },
  ];

  if (status === WalletStatus.WALLET_CONNECTED && exchangeRate) {
    const value = parseFloat(
      ((1 / exchangeRate) * hbarX).toFixed(precision)
    ).toLocaleString(undefined, {
      maximumFractionDigits: precision,
    });
    exchangeStatusData.push({
      title: `Total ${coinNameX} value`,
      value: `~${value}`,
      option: coinName,
      tooltip: `Total ${coinNameX} value`,
    });
  }

  return <ExchangeStatusWrapper data={exchangeStatusData} />;
};

export default ExchangeInfo;
